import Api from "../../../services/Api";
import BaseApi from "../../../services/baseApi";

class Service_se {
    constructor() {
        this.entity = 'dailyAccountSms';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(search,page_,size_) {
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/list',
            headers: {'Content-Type': 'application/json'},
        })
    }


    save(model) {
        return Api.save(this.entity,model)
    }




}
export default new Service_se();
